export default __webpack_public_path__ + "static/media/ao-phenomenon-interpretation.6f9b7e48.webp";